export default "__VITE_PUBLIC_ASSET__e18c751a__"